// Use: const _ = make_(localTranslations)
// _('i18nId') is translation

import {getTranslations} from 'state/actions'
import {getCategories} from 'state/ducks/categories'
import {getSources} from 'state/ducks/sources'
import store from 'state/store'

let dict
let requested = false
let promiseForTranslations

export let getPromiseForTranslations = () => {

    if (!dict && !requested) {
        make_()
    }

    return promiseForTranslations
}

const make_ = (prefix) => {
	return (id, forceLang = null) => {
		if (!dict) {
			const sDict = store.getState().dict
			if (sDict._gen) {
				dict = sDict
			} else {
				if (!requested) {

                    promiseForTranslations = new Promise((resolve, reject) => {

                        window.setTimeout(() => store.dispatch(getTranslations()).then((result)=>{
                            return resolve(result)
                        }), 0)

                    })
                    dict
                    //promiseForTranslations = new Promise((resolve, reject) => { resolve() })
                    promiseForTranslations.then((result)=>{
                        return result
                    })

                    //setTimeout(() => store.dispatch(getTranslations()), 0)
				}
				requested = true
				return '…'
			}
		}

		return (prefix && dict[`${prefix}_${id}`] || dict[id] || {})[(forceLang ? forceLang : global.lang)] || (prefix?`[${prefix}_${id}]`:`[${id}]`)
	}
}

let catsDict
let catsRequested = false
export const catIdToString = (catId, callBack = null) => {
	if (!catsDict) {
		const sDict = store.getState().categories
		if (sDict._gen) {
            catsDict = sDict
            if (typeof callBack == 'function') {
                callBack(null, null)
            }
		} else {
			if (!catsRequested) {
                setTimeout(() =>
                store.dispatch(getCategories())
                .then((result) => {
                    if (typeof callBack === 'function') {
                        callBack(result, null)
                    }
                })
                .catch((err) => {
                    if (typeof callBack === 'function') {
                        callBack(null, err)
                    }
                })
                , 0)
			} else {
                if (typeof callBack == 'function') {
                    callBack(null, null)
                }
            }

            catsRequested = true

			// While we are fetching, show nothing
			return '…'
		}
	} else {
        if (typeof callBack == 'function') {
            callBack(null, null)
        }
    }

	const cat = catsDict[catId]
	if (cat) {
		const name = cat[global.lang] || cat.key || `[${catId}]`
		return name
	}
	return `[${catId} (?)]`
}

let sourcesDict
let sourcesRequested = false
export const sourceIdToObj = (sourceId, callBack = null) => {
	if (!sourcesDict) {
		const sDict = store.getState().sources
		if (sDict._gen) {
            sourcesDict = sDict
            if (typeof callBack == 'function') {
                callBack(null, null)
            }
		} else {
			if (!sourcesRequested) {
                setTimeout(() =>
                    store.dispatch(getSources())
                    .then((result)=>{
                        if (typeof callBack == 'function') {
                            callBack(result, null)
                        }
                    })
                    .catch((err)=>{
                        if (typeof callBack == 'function') {
                            callBack(null, err)
                        }
                    })
                , 0)
			} else {
                if (typeof callBack == 'function') {
                    callBack(null, null)
                }
            }
			sourcesRequested = true
			// While we are fetching, show nothing
			return {name: '…', url: ''}
		}
	} else {
        if (typeof callBack == 'function') {
            callBack(null, null)
        }
    }

	const source = sourcesDict[sourceId]
	if (source) {
		const name = source[global.lang] || source.key || `[${sourceId}]`
		return {name, url: source.url}
	}
	return `[${sourceId} (?)]`
}

export default make_



// WEBPACK FOOTER //
// ./lib/i18n.js